module.exports = __webpack_public_path__ + "img/qrCode_05.b6c738f8.jpg";